import React, { PropsWithChildren } from 'react';

import { ToastContainer } from '@tunz/message-displayer';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Portal from '../Components/Portal';
import { LoginRequired } from '../Components/Login';

import './App.scss';
import PasswordResetForm from '../Components/Password/PasswordResetForm';
import UnsuspendUserForm from '../Components/Unsuspend/UnsuspendUserForm';

type Props = PropsWithChildren;

const App: React.FC<Props> = ({ children }: Props) => (
	<>
		<ToastContainer
			position="top-right"
			style={{ marginTop: '60px' }}
			autoClose={5000}
			closeOnClick={false}
			closeButton
			pauseOnHover
		/>
		<Router>
			<Routes>
				<Route
					path="/*"
					element={
						<LoginRequired>
							<Portal>{children}</Portal>
						</LoginRequired>
					}
				/>
				<Route path="/resetPassword" element={<PasswordResetForm />} />
				<Route path="/unsuspenduser" element={<UnsuspendUserForm />} />
			</Routes>
		</Router>
	</>
);

export default App;
